import {
  AiFillHeart,
  AiFillStar,
  AiOutlineHeart,
  AiOutlineMinus,
  AiOutlinePlus,
} from "react-icons/ai";
import { useContext, useEffect, useMemo, useState } from "react";
import { MdKeyboardArrowDown } from "react-icons/md";
import { AppContext } from "@/contexts/appContexts";
import { useRouter } from "next/router";

// import Share from "./Share";
import RulesPDP from "./Rules";
import Branches from "./Branches";
import ImgTag from "../Helpers/ImgTag";
import CartInfo from "../Modals/CartInfo2";
import AddtoCart from "../Helpers/AddtoCart";
import InstallmentWidgets from "./installment";
import ConfigueOptions from "./ConfigueOptions";
import AddToCompare from "../compare/AddToCompare";
import PreOrderLabel from "../Helpers/PreOrderLabel";
import Share from "../share";
import ActionButtons from "../Helpers/ActionButtons";
import useScreenSize from "@/hooks/global/useDisplay";
import { validateProductPrice } from "@/utils/product";
import {
  addToWishList,
  removeFromWishList,
} from "@/utils/wishlist/addAndRemoveWishlist";
import { useSession } from "next-auth/react";
import toast from "react-hot-toast";
import PriceWithCurrency from "@/components/Helpers/PriceWithCurrency";
import DeliveryInformations from "./DeliveryInformations";
import { getCookie } from "cookies-next";

import {
  trackWishListProductAfterSearch,
  trackWishListProduct,
} from "@/utils/searchClients";
import EWPdpSelector from "../ExtendedWarranty/EWPdpSelector";
import EWMoreInfoModal from "../ExtendedWarranty/EWMoreInfoModal";
import { groupPricesByCategory } from "../ExtendedWarranty/ewModel";
import useEwSlotsScrollCap from "@/hooks/useEwSlotsScrollCap";
import { useTranslation as useEWTranslation } from "next-i18next";

function Detail({
  t,
  setShowBranches,
  store,
  city,
  relatedProducts,
  setCity,
  product,
  ratings,
  queryId,
  indexName,
  paymentWidgets,
  extendedWarranty,
  // isMobile,
}) {
  const { data: session } = useSession();
  const { wishList, setwishList, isCityHavefastDelivery } =
    useContext(AppContext);
  const { isResponsive } = useScreenSize();
  const [sku, setSku] = useState(
    Array.isArray(product?.sku) ? product?.sku?.at(0) : product?.sku,
  );
  const [productOptions, setProductOptions] = useState(null);
  const [price, setPrice] = useState({});
  const [cityBox, setCityBox] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [cities, setCities] = useState([]);
  const [qty, setQty] = useState(1);
  // PDP extended-warranty slots, one per qty. Oldest first (slots[0]); rendered
  // reversed so the newest shows on top. Slot shape: { priceId: number | null }.
  const [ewSlots, setEwSlots] = useState([{ priceId: null }]);

  // Group the flat EW `prices[]` into categories (by `code`, labelled via
  // `program_groups` — both straight from BE; label already localised) for the
  // 2-level PDP selector. Empty → []; the section is gated on prices.length anyway.
  const ewCategories = useMemo(
    () =>
      groupPricesByCategory(
        extendedWarranty?.prices,
        extendedWarranty?.program_groups,
      ),
    [extendedWarranty],
  );
  // "more info" popup (BE-returned HTML) — one instance for the whole EW section.
  const [ewMoreInfoOpen, setEwMoreInfoOpen] = useState(false);

  const { t: ewT } = useEWTranslation("extended_warranty");
  const { locale } = useRouter();
  const foundItem = useMemo(() => {
    if (product && wishList) {
      return wishList.find((item) => item.sku === product.sku);
    }
    return null;
  }, [wishList, product]);
  const [isFav, setIsFav] = useState(!!foundItem);

  // Keep the slot count in sync with qty (grow at the end, shrink from the
  // start); selections on surviving slots are preserved.
  useEffect(() => {
    const target = qty || 1;
    setEwSlots((prev) => {
      if (prev.length === target) return prev;
      if (prev.length < target) {
        return [
          ...prev,
          ...Array.from({ length: target - prev.length }, () => ({
            priceId: null,
          })),
        ];
      }
      return prev.slice(prev.length - target);
    });
  }, [qty]);

  // Cap the EW list at 3 slots with internal scroll on desktop (shared hook).
  const { scrollRef: ewScrollRef, maxHeight: ewMaxHeight } =
    useEwSlotsScrollCap(ewSlots.length);

  const customer_id_session = session?.user?.id;
  const entity_id = product?.objectID ? product?.objectID : product?.entity_id;

  const region_id = getCookie("region_id");

  useEffect(() => {
    if (region_id) {
      setCity(
        (store?.items || []).find((item) => item.location.state === region_id)
          ?.location.city,
      );
    }
    setCities(store?.items);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [store?.items, region_id]);

  const handleSendAlgoliaEvent = (isShare = false) => {
    if (queryId) {
      trackWishListProductAfterSearch(
        [`${entity_id}`],
        indexName,
        queryId,
        isShare,
      );
    } else {
      trackWishListProduct([`${entity_id}`], indexName, isShare);
    }
  };

  const toggleFavorite = () => {
    if (isFav) {
      removeFromWishList(product, wishList, setwishList, customer_id_session);
      toast.success(
        locale === "ar"
          ? "تمت الإزالة من المفضلة"
          : "Product removed from Favourites",
      );
    } else {
      addToWishList(product, wishList, setwishList, customer_id_session);
      toast.success(
        locale === "ar"
          ? "تمت الإضافة إلى المفضلة"
          : "Product Added To Favourites",
      );
      handleSendAlgoliaEvent();
    }
    setIsFav(!isFav);
  };

  useEffect(() => {
    setCities(store?.items);
  }, [store?.items]);
  useEffect(() => {
    setPrice(validateProductPrice(product?.prices_with_tax));
  }, [product]);

  let arrOfFiltrationCities = [];

  return (
    <div className="col-span-6 p-2 py-2 bg-white rounded-md max-[991px]:col-span-12">
      <CartInfo
        {...{
          product,
          active: showModal,
          setActive: setShowModal,
          related_products: [],
        }}
      />
      {isResponsive && (
        <ActionButtons
          product={product}
          queryId={queryId}
          indexName={indexName}
        />
      )}
      <h1 className="mx-2 text-2xl font-semibold max-[570px]:text-lg">
        {product?.name || ""}
      </h1>
      {ratings?.length > 0 && (
        <div className="flex items-center justify-between mx-2 my-2">
          <span className="text-base font-normal">
            {`(`} {ratings?.length} {t("Reviews")} {`)`}
          </span>{" "}
          <span className="flex items-center" dir="ltr">
            {[...Array(5).keys()].map((i) => (
              <AiFillStar key={i} className="mx-1 text-gold" size="16px" />
            ))}
          </span>
        </div>
      )}
      <div className="mx-2 mt-4">
        <h5 className="mb-2 text-xl font-semibold">{t("Price")}</h5>
        <div className="flex flex-wrap items-center justify-between">
          <div className="flex flex-row items-center justify-between w-full flex-nowrap">
            <div className="flex items-center max-[570px]:mb-2">
              {price?.discounted_percentage === 0 ? (
                <h6 className="flex items-center gap-1 text-xl font-semibold text-red">
                  <PriceWithCurrency
                    amount={price?.original_price}
                    iconClassName="w-5 h-5"
                    className="gap-1"
                  />
                </h6>
              ) : (
                <>
                  <h6 className="flex items-center gap-1 text-xl font-semibold text-red">
                    <PriceWithCurrency
                      amount={price.discounted_price}
                      iconClassName="w-5 h-5"
                      className="gap-1"
                    />
                  </h6>
                  <h6 className="flex items-center gap-1 mx-3 font-semibold line-through text-zinc-500">
                    <PriceWithCurrency
                      amount={price?.original_price}
                      iconClassName="size-4"
                      className="gap-1"
                    />
                  </h6>
                </>
              )}
            </div>

            {price.discounted_percentage > 0 ? (
              <div className="flex flex-col items-end justify-end gap-1 font-semibold ">
                <div className="bg-[#95FBDE] rounded-full px-2 py-.5 text-md">
                  {Number(price?.discount_amount.replace(/,/g, "")) >= 50 ? (
                    <span className="flex items-center gap-1">
                      <span>{locale === "en" ? "Save" : "وفر"}</span>
                      <PriceWithCurrency
                        amount={price?.discount_amount}
                        iconClassName="size-4"
                        className="gap-1"
                      />
                    </span>
                  ) : (
                    `${locale === "en" ? "OFF" : "خصم"} ${
                      price?.discounted_percentage
                    }%`
                  )}
                </div>
                <div className="px-2 py-1 text-xs bg-orange-300 rounded-full">
                  {Number(price?.discount_amount.replace(/,/g, "")) < 50 ? (
                    <span className="flex items-center gap-1">
                      <span>{locale === "en" ? "Save" : "وفر"}</span>
                      <PriceWithCurrency
                        amount={price?.discount_amount}
                        iconClassName="w-3 h-3"
                        className="gap-1"
                      />
                    </span>
                  ) : (
                    `${locale === "en" ? "OFF" : "خصم"} ${
                      price?.discounted_percentage
                    }%`
                  )}
                </div>
              </div>
            ) : null}
          </div>

          <div className="flex items-center justify-start gap-2">
            {isCityHavefastDelivery &&
            product?.fast_delivery?.length &&
            product?.fast_delivery[0] === true &&
            !product?.back_orders === 101 ? (
              <div className="flex items-center px-3 py-1 rounded-full bg-lightgold text-blue max-[570px]:mb-2">
                <ImgTag
                  // src="/svgs/delivery.svg"
                  src={`${process.env.NEXT_PUBLIC_CLOUD_FLAIR}/w=25&h=25,fit=contain,format=auto,quality=75/delivery.svg`}
                  className="h-[25px] w-[25px] object-fill"
                  height={1000}
                  width={1000}
                  alt=""
                />
                <span className="mx-2 text-xs font-semibold">
                  {locale == "ar" ? "  توصيل فى نفس اليوم" : "Today's Delivary"}
                </span>
              </div>
            ) : null}
            {product?.back_orders === 101 && (
              <div className="mt-2 bg-blue text-lightgold min-h-[33px] py-1 px-3 rounded-full flex items-center max-[570px]:mb-2">
                <span className="mx-2 text-xs font-semibold">
                  {locale == "ar" ? "طلب مسبق" : "Pre-order"}
                </span>
              </div>
            )}
          </div>
        </div>
        <PreOrderLabel
          fromPDP={true}
          isPreOrder={product?.back_orders === 101}
          label={product?.preorder_note}
          className="my-3 w-fit"
        />
      </div>
      <div className="flex flex-col gap-6 mx-2 max-[570px]:block ">
        <ConfigueOptions
          {...{ product, t, setSku, setPrice, setProductOptions }}
        />
        <div className="max-[570px]:mb-3 max-[570px]:mx-0 max-[570px]:w-[150px] flex gap-4 items-end mb-2">
          <label className="block mb-1 font-semibold text-zinc-400">
            {t("Quantity")}
          </label>
          <div
            className={`flex items-center flex-row-reverse justify-between px-3 py-2 -mx-2 border rounded-full w-28`}
          >
            <button
              disabled={!product?.stock?.is_in_stock}
              onClick={() => setQty((prev) => prev + 1)}
              className="transition-transform text-md hover:text-slate-700 active:scale-110 disabled:cursor-not-allowed disabled:text-slate-500"
            >
              <AiOutlinePlus />
            </button>
            <span className="w-[70px] outline-none mx-2 text-center">
              {qty}
            </span>
            <button
              disabled={qty === 1 || !product?.stock?.is_in_stock}
              onClick={() => setQty((prev) => prev - 1)}
              className="transition-transform text-md hover:text-slate-700 active:scale-110 disabled:cursor-not-allowed disabled:text-slate-500"
            >
              <AiOutlineMinus />
            </button>
          </div>
        </div>
      </div>

      <InstallmentWidgets
        amount={+product?.prices_with_tax?.price ?? 0}
        paymentWidgets={paymentWidgets}
        locale={locale}
      />

      {store?.items?.length > 0 && (
        <div className="p-3 my-2 border rounded-md">
          <div className="flex items-center mb-2">
            <ImgTag
              src={`${process.env.NEXT_PUBLIC_CLOUD_FLAIR}/w=20&h=20,fit=contain,format=auto,quality=75/branch-delivery.png`}
              className="object-cover w-auto h-auto mx-2 rounded-full"
              height={1000}
              width={1000}
              alt=""
            />
            <h4 className="text-lg">{t("ViewAvailability")}</h4>
          </div>
          <div className="relative p-2 border rounded-md">
            <div
              className="flex items-center justify-between cursor-pointer text-zinc-500"
              onClick={() => setCityBox(!cityBox)}
            >
              <span className="font-semibold">
                {city || t("common:ChooseCity")}
              </span>
              <MdKeyboardArrowDown
                size="24px"
                className={cityBox ? "rotate-180" : "rotate-0"}
              />
            </div>
            {cityBox && (
              <div className="max-h-[200px] overflow-y-auto disable-scrolling absolute top-[110%] left-0 w-full bg-white shadow-xl z-50 rounded-md p-2">
                <input
                  onChange={(e) =>
                    setCities((cities) =>
                      !e.target.value
                        ? store?.items
                        : cities.filter((city) =>
                            city.location.city.includes(e.target.value),
                          ),
                    )
                  }
                  placeholder={t("common:ChooseCity")}
                  className="sticky -top-2 outline-0 w-full mb-1 p-1.5 border border-red rounded-sm"
                />
                <ul className="mt-0.5">
                  {!cities.length ? (
                    <li className="border text-center rounded-sm mb-0.5 p-1">
                      {t("NoData")}
                    </li>
                  ) : (
                    cities.map((item, i) => {
                      if (arrOfFiltrationCities.length > 0) {
                        let index = arrOfFiltrationCities.indexOf(
                          item.location.state,
                        );
                        if (index < 0) {
                          arrOfFiltrationCities.push(item.location.state);
                          return (
                            <li
                              onClick={() => {
                                setCityBox(!cityBox);
                                setCity(item.location.city);
                              }}
                              key={i}
                              className="border rounded-sm mb-0.5 last:mb-0 hover:bg-blue hover:text-white hover:border-red p-1 cursor-pointer"
                            >
                              {item.location.city}
                            </li>
                          );
                        } else {
                          return null;
                        }
                      } else {
                        arrOfFiltrationCities.push(item.location.state);
                        return (
                          <li
                            onClick={() => {
                              setCityBox(!cityBox);
                              setCity(item.location.city);
                            }}
                            key={i}
                            className="border rounded-sm mb-0.5 last:mb-0 hover:bg-blue hover:text-white hover:border-red p-1 cursor-pointer"
                          >
                            {item.location.city}
                          </li>
                        );
                      }
                    })
                  )}
                </ul>
              </div>
            )}
          </div>
          {city && (
            <div className="p-2">
              <h4 className="font-bold text-emerald-600">
                {t("AvailableIn")}{" "}
                {
                  store?.items.filter((item) => item.location.city === city)
                    .length
                }{" "}
                {t("Branches")}
              </h4>
              <Branches
                branches={store?.items
                  .filter((item) => item.location.city === city)
                  .slice(0, 2)}
              />
              {store?.items.filter((item) => item.location.city === city)
                .length > 2 && (
                <button
                  onClick={() => setShowBranches(true)}
                  className="w-full p-2 font-semibold text-white rounded-full bg-red"
                >
                  {t("show")}
                </button>
              )}
            </div>
          )}
        </div>
      )}

      {/* No `cart_rule` gate: a Trade-in offer can exist without any cart rule,
          and the block was hidden for those. RulesPDP renders null when empty. */}
      <RulesPDP
        offers={product?.cart_rule}
        locale={locale}
        sku={sku}
        hasTradeIn={product?.trade_in}
      />

      {product?.product_fees?.length > 0 && (
        <div className="grid grid-cols-1 gap-2 mb-2">
          {product?.product_fees.map((fee, i) => (
            <div key={i} className="p-4 border rounded-sm">
              <h4 className="text-lg font-semibold text-red">
                {fee?.labels
                  ? fee?.labels[locale === "en" ? "2" : "14"]?.title
                  : ""}
              </h4>
              <p className="mb-2 text-zinc-500">
                {fee?.labels
                  ? fee?.labels[locale === "en" ? "2" : "14"]?.description
                  : ""}
              </p>
              {Object.values(fee?.options || {}).map((option, idx) => (
                <div key={idx} className="flex items-center justify-between">
                  <h5 className="text-lg font-semibold">
                    {locale === "ar"
                      ? option?.title_ar || ""
                      : option?.title || ""}
                  </h5>
                  <h4 className="text-lg font-semibold">
                    {parseInt(option.price || 0).toFixed(1)} SAR
                  </h4>
                </div>
              ))}
            </div>
          ))}
        </div>
      )}

      {extendedWarranty?.prices?.length > 0 && (
        <div
          ref={ewScrollRef}
          className={`flex flex-col gap-2 ${
            ewMaxHeight != null ? "overflow-y-auto pe-2" : ""
          }`}
          style={
            ewMaxHeight != null ? { maxHeight: `${ewMaxHeight}px` } : undefined
          }
        >
          {/* Render newest on top: ewSlots[0] is oldest, so iterate end→start.
              The queue index is the stable React key. */}
          {ewSlots
            .map((slot, idx) => ({ slot, idx }))
            .reverse()
            .map(({ slot, idx }, visualIndex) => {
              const selectedCategoryId = slot.categoryId ?? null;
              return (
                <div key={idx}>
                  {qty > 1 && (
                    <div
                      className="flex items-center gap-2 px-1 pt-2"
                      dir={locale === "ar" ? "rtl" : "ltr"}
                    >
                      <span className="text-[14px] text-[#00269A] font-[500]">
                        {ewT("forProduct", {
                          defaultValue:
                            "Al Manea Guarantee (For product {{n}})",
                          n: visualIndex + 1,
                        })}
                      </span>
                    </div>
                  )}
                  <EWPdpSelector
                    locale={locale}
                    categories={ewCategories}
                    configuration={extendedWarranty?.configuration}
                    selectedCategoryId={selectedCategoryId}
                    selectedPriceId={slot.priceId || null}
                    onMoreInfo={() => setEwMoreInfoOpen(true)}
                    onCategoryChange={(categoryId) =>
                      setEwSlots((prev) =>
                        prev.map((s, i) =>
                          i === idx ? { categoryId, priceId: null } : s,
                        ),
                      )
                    }
                    onDurationChange={(priceId) =>
                      setEwSlots((prev) =>
                        prev.map((s, i) =>
                          i === idx
                            ? { categoryId: selectedCategoryId, priceId }
                            : s,
                        ),
                      )
                    }
                    onDurationClear={() =>
                      setEwSlots((prev) =>
                        prev.map((s, i) =>
                          i === idx
                            ? { categoryId: selectedCategoryId, priceId: null }
                            : s,
                        ),
                      )
                    }
                  />
                </div>
              );
            })}
          <EWMoreInfoModal
            isOpen={ewMoreInfoOpen}
            onClose={() => setEwMoreInfoOpen(false)}
            locale={locale}
          />
        </div>
      )}

      <DeliveryInformations locale={locale} />

      <div className="flex items-center justify-between gap-2 mb-4 max-sm:flex-col">
        <AddtoCart
          {...{
            qty,
            product,
            sku,
            productOptions,
            relatedProducts,
            fastBuy: true,
            fromPDP: true,
            indexName,
            queryId,
            // Build the EW slot array — what FE shows == what FE sends.
            //
            // PDP renders ewSlots reversed (newest at top, see render block above):
            //    visible TOP    = ewSlots[N-1]   → mapped to Magento position 0
            //    visible BOTTOM = ewSlots[0]     → mapped to Magento position N-1
            //
            // Cart renders position-ascending (top = pos 0, bottom = pos N-1),
            // so the same visual order is preserved across PDP → cart.
            //
            // Magento requires ONE entry per unit — the array length must equal
            // qty (else BE rejects: "selections sent (N) must match the number
            // of new units being added (M)"). So we send a full-length array:
            //   filled slot → { extended_warranty_id, price_id, position }
            //   empty slot  → { position } only
            // We omit the field entirely only when nothing was selected at all.
            extendedWarrantys:
              extendedWarranty?.extended_warranty_id &&
              ewSlots.some((slot) => slot.priceId != null)
                ? ewSlots.map((slot, idx) => {
                    const position = ewSlots.length - 1 - idx;
                    return slot.priceId != null
                      ? {
                          extended_warranty_id:
                            extendedWarranty.extended_warranty_id,
                          price_id: slot.priceId,
                          position,
                        }
                      : { position };
                  })
                : undefined,
          }}
        />
      </div>
      {!isResponsive && (
        <div className="flex items-center justify-center gap-4">
          <button
            type="button"
            onClick={toggleFavorite}
            className={`flex justify-center items-center gap-2`}
          >
            {!isFav ? (
              <>
                <AiOutlineHeart size={20} />
                <span>{locale === "ar" ? "المفضلة" : "favorite"}</span>
              </>
            ) : (
              <>
                <AiFillHeart className="text-red" size={20} />
                <span>{locale === "ar" ? "المفضلة" : "favorite"}</span>
              </>
            )}
          </button>
          <AddToCompare
            fromPDP
            product={product}
            className="px-0 border-none w-fit text-zinc-500"
          >
            <span>{locale === "ar" ? "قارن" : "Compare"}</span>
          </AddToCompare>
          <Share
            title={product?.name}
            description={product?.description}
            t={t}
            handleSendAlgoliaEvent={handleSendAlgoliaEvent}
          />
        </div>
      )}
    </div>
  );
}

export default Detail;
